module.exports = __webpack_public_path__ + "static/img/Moeaki-Fotuaika.0ba7266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Moeaki-Fotuaika.jpg
// module id = diwp
// module chunks = 0